import type React from 'react';

import { useGetResources } from '@hooks/useGetResources';

import type { HNVerktoyFrontend } from '@src/types/Resources';

import { TagComponent } from './tag-component';

interface Props {
  estimatedTime: number;
}

const AntattTidTag = ({ estimatedTime }: Props): React.JSX.Element => {
  const resources = useGetResources();
  const AntattTidKalkulator = (estimatedTime: number, resources?: HNVerktoyFrontend): string => {
    const hours = Math.floor(estimatedTime / 60);
    const minutes = estimatedTime % 60;
    let hoursString = '';
    if (hours === 1) {
      hoursString = `${hours} ${resources?.verktoyDetails_hour}`;
    } else if (hours > 1) {
      hoursString = `${hours} ${resources?.verktoyDetails_hours}`;
    }
    const timeRequiredString = minutes ? `${hoursString} ${minutes} ${resources?.verktoyDetails_minutes}` : hoursString;
    return timeRequiredString.trim();
  };

  return (
    <TagComponent
      tagTitle={resources?.tagTitle_antattVarighet}
      tagValue={AntattTidKalkulator(estimatedTime, resources)}
      isPlainText={true}
    />
  );
};

export default AntattTidTag;
